// import { normalizeBankCard, normalizeEmail, normalizePhone, validateBankCardByLuhn, validatePhone } from 'svag-utils'
import { normalizeEmail } from 'svag-utils'
import { z } from 'zod'

export const zStringRequired = z
  .string({
    message: 'Required',
    required_error: 'Required',
  })
  .min(1, 'Required')
// .max(3_000, 'Too long value')
export const zStringOptional = z
  .string()
  // .max(3_000, 'Too long value')
  .optional()
export const zStringOptionalNullable = zStringOptional.nullable()
export const zEmptyStringOrNull = z.union([z.literal(''), z.null(), z.undefined()])
export const zSNRequired = z.coerce.number().int().positive()
export const zSNOptionalNullable = z
  .union([zEmptyStringOrNull, zSNRequired])
  .transform((val) => (val ? Number(val) : null))
export const zSNRequiredStrict = z.number().int().positive()
export const zSNOptionalNullableStrict = z
  .union([zEmptyStringOrNull, zSNRequiredStrict])
  .transform((val) => (val ? Number(val) : null))
export const zPasswordRequired = z
  .string({})
  .min(8, 'Password must be at least 8 characters')
  .max(1000, 'Password is too long')
  .regex(
    // should contain at least one digit
    /\d/,
    'Password must contain at least one digit'
  )
  .regex(
    // should contain at least one lowercase letter
    /[a-zа-я]/,
    'Password must contain at least one lowercase letter'
  )
  .regex(
    // should contain at least one uppercase letter
    /[A-ZА-Я]/,
    'Password must contain at least one uppercase letter'
  )
  .regex(
    // should contain at least one special character
    /[^a-zA-Zа-яА-Я\d]/,
    'Password must contain at least one special character'
  )
export const zEmailRequired = zStringRequired.email('Incorrect e-mail').transform((val) => normalizeEmail(val))
export const zEmailOptionalNullable = z.union([zEmptyStringOrNull, zEmailRequired]).transform((val) => val || null)
export const zUrlRequired = zStringRequired.url('Incorrect URL')

export const zPasswordsMustBeTheSame =
  (passwordFieldName: string, passwordAgainFieldName: string) => (val: any, ctx: z.RefinementCtx) => {
    if (val[passwordFieldName] !== val[passwordAgainFieldName]) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Passwords must be the same',
        path: [passwordAgainFieldName],
      })
    }
  }

export const zGosNumberRu = z
  .string()
  .regex(/^[^A-Za-z]*$/, 'В госномере не должно быть английских букв, замените их на русские')
export const zGosNumberRuOptional = zGosNumberRu.optional().nullable()
export const zGosNumberRuRequired = zGosNumberRu.min(1, 'Госномер не может быть пустым')
